import {MoonIcon} from "@chakra-ui/icons";
import moment, {Moment} from "moment/moment";
import {Checkbox, VStack} from "@chakra-ui/react";
import {useTranslations} from "next-intl";
import {DayHours} from "../../tools/groupHours";
import {useMemo} from "react";
import {TimePicker} from "@mui/x-date-pickers";

const pickerSlotProps = {
    textField: {
        fullWidth: false,
        size: "small",
        style: {width: "120px"}
    }
}

function onTimeChange(type: string, time: Moment| null, current: DayHours): DayHours {
    if (!time) return current
    const timeNum = time.isValid() ? +time.format("HHmm") : undefined
    if (type == 'from') {
        return {
            ...current,
            start: timeNum,
            end: doesEndNextDay(timeNum, current.end) ? (current.end ? (current.end % 2400) + 2400 : current.end) : current.end
        }
    } else if (type == 'to') {
        return {
            ...current,
            end: doesEndNextDay(current.start, timeNum) ? (timeNum ? timeNum + 2400 : undefined) : timeNum
        }
    } else {
        console.error(`onTimeChange: Unknown type=${type}`)
        return current
    }
}

export function StartTimePicker(
    {value, onChange}: {value: DayHours, onChange: (value: DayHours) => void},
) {
    const t = useTranslations("addbar")

    // @ts-ignore
    return (
        <VStack alignItems="start" h="100%">
            {/* @ts-ignore*/}
            <TimePicker slotProps={pickerSlotProps}

                        value={numToMoment(value.start)}
                        onChange={timeVal => onChange(onTimeChange('from', timeVal, value))}
            />
            {value.start !== undefined && (value.start % 2400) < 600 && (
                <Checkbox
                    size="sm"
                    isChecked={value.start > 2359}
                    onChange={e => onChange({
                        end: value.end !== undefined ? (e.target.checked ? (value.end % 2400) + 2400 : (value.end % 2400)) : undefined,
                        start: value.start !== undefined ? (e.target.checked ? (value.start % 2400) + 2400 : (value.start % 2400)) : undefined
                    })}
                    icon={value.start > 2359 ? <MoonIcon/> : <></>}>{t("starts_next_day")}</Checkbox>
            )}
        </VStack>
    )
}

export function numToTime(timeNum: number|undefined, fallback: string = ""): string {
    const number = timeNum
    if (number !== undefined) {
        const nextDay = number > 2359
        const str = (nextDay ? number % 2400 : number).toString()
        const padded = str.padStart(4, '0')
        return moment(padded, "Hmm").format("LT")//str.substring(0, 2) + ":" + str.substring(2)
    } else return fallback
}

function numToMoment(timeNum: number|undefined): moment.Moment {
    const str = numToTime(timeNum)
    return moment(str, "HH:mm")
}

function doesEndNextDay(start: number|undefined, end: number|undefined): boolean {
    const startMoment = numToMoment(start)
    const endMoment = numToMoment(end)
    const crossesMidnight = startMoment.isValid() && endMoment.isValid() && startMoment > endMoment

    return (start !== undefined && start > 2359) || crossesMidnight
}

export function EndTimePicker(
    {value, onChange}: {value: DayHours, onChange: (value: DayHours) => void},
) {
    const t = useTranslations("addbar")
    const endsNextDay = useMemo(() => doesEndNextDay(value.start, value.end), [value])
    return (
        <>
            <VStack alignItems="start" justifyItems="start" >
                {/* @ts-ignore*/}
                <TimePicker value={numToMoment(value.end)} onChange={timeVal => onChange(onTimeChange('to', timeVal, value))} slotProps={pickerSlotProps}/>
                {endsNextDay && <Checkbox size="sm" icon={<MoonIcon/>} isChecked={endsNextDay} isDisabled={true}>
                    {t("ends_next_day", {time: value.end ? numToTime(value.end) : ""})}
                </Checkbox>}
            </VStack>
        </>
    )
}